<template>
    <div class="moe_tooltip">
        <!-- <el-tooltip class="box-item" :disabled="!isOverflow" effect="dark" :content="contentText" placement="top"> -->
            <div ref="contentTextBox" class="toverflow" :style="{ width: contentWidth + 'px' }">{{ contentText }}</div>
        <!-- </el-tooltip> -->
    </div>
</template>

<script>
export default {
    name: 'GjkcH5MoeTooltip',
    props: {
        contentText: {},
        contentWidth: {}
    },

    data() {
        return {
            isOverflow: true
        };
    },
    watch:{
        contentText:{
            handler(){
                this.checkOverflow();
            },
            // immediate:true,
            deep:true
        }
    },

    mounted() {
        
    },

    methods: {
        checkOverflow() {
            if (!this.contentText) return
            const element = this.$refs.contentTextBox;
            if(!element) return
            this.isOverflow = element.scrollWidth > element.clientWidth;
        }
    },
};
</script>

<style lang="scss" scoped>
.moe_tooltip {
    text-align: center;
}
</style>